<template>
    <div>
        <van-tabbar @change="tabbarChange" route placeholder >
             <!-- :badge="processorList.length" 显示未读数徽标，但是为0时也显示 -->
            <van-tabbar-item replace to="/tabbarPending" icon="todo-list-o" :badge="processorList > 0 ? processorList > 99 ? '99+' : processorList : '' " >待我处理</van-tabbar-item>
            <van-tabbar-item replace to="/home" icon="notes-o">我的申请</van-tabbar-item>
            <van-tabbar-item replace to="/tabbarProcessed" icon="setting-o">我相关的
                <template #icon>
                    <span class="iconfont icon-copy" style="font-size: large;"></span>
                </template>
            </van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
export default {
    data() {
        return {
            processorList: 0,
            url:{
                querybySubmitor: 'realrigteaf/querybySubmitor',   //获取我申请的,无参，get
                querybyHandler: 'realrigteaf/getHanlerForm',   //获取待我处理，无参，get
                querybyRelevancer: 'realrigteaf/getRelevance',   //获取我相关，无参，get
            },
        };
    },
    created() {
        this.myProcessedList_API()  //待我处理
        // 未处理表单数
        this.processorList = this.$store.state?.formProcessList?.length
        this.mySubmitList_API()
        this.myRelatedList_API()
    },
    methods: {
        tabbarChange(index) {
            // switch (index) {
            //     case 0:
            //         this.myProcessedList_API()
            //         break;
            //     case 1:
            //         this.mySubmitList_API()
            //         break;
            //     case 2:
            //         this.myRelatedList_API()
            //         break;
            //     default:
            //         break;
            // }
        },
        // 查询我提交的
        mySubmitList_API() {
            this.$get(this.url.querybySubmitor).then(submitRes => {
                this.$store.commit('SET_FORMDATALIST', submitRes.result != null ? submitRes.result : [])            
            })
        },
        // 查询待我处理的
        myProcessedList_API() {
            this.$get(this.url.querybyHandler).then(processRes => {
                // 未处理表单数
                this.processorList = processRes.result.length
                this.$store.commit('SET_FORMPROCESSLIST', processRes.result != null ? processRes.result : []) 
            })
        },
        // 查询我相关的
        myRelatedList_API() {
            this.$get(this.url.querybyRelevancer).then(releRes => {
                this.$store.commit('SET_FORMRELATEDLIST', releRes.result != null ? releRes.result : []) 
            })
        },
    },
};
</script>

<style lang="less" scoped>
    /deep/.van-tabbar--fixed {
        max-width: 740px;
        left: unset;
    }
    /deep/.van-tag {
        padding: 1px 4px;
    }
</style>